import axios from "axios";

export default {
    find: () => axios.get("/api/grid_layouts/find"),
    createLayout: (obj) => axios.post("/api/grid_layouts/create_layout", obj),
    updateLayout: (obj) => axios.post("/api/grid_layouts/update_layout", obj),
};
